import React from "react";
import { Box, Container, Grid, Link } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import Content from "../content-box/Content";

function Cityslider() {
const { stateData } = Content[0];
  

  return (
    <section>
    <Box className="blogSliderBox">
      <Container maxWidth="md">
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12}>
            <Box className="templeInnerHeading" textAlign="center">
              <h2>{Content[0].stateHeading}</h2>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Swiper className="swiperCitySlider"
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={20}
              slidesPerView={4}
              // navigation
              pagination={{ clickable: true }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              breakpoints={{
                0: { slidesPerView: 1 },
                576: { slidesPerView: 2 },
                768: { slidesPerView:4 },
                1200: { slidesPerView: 4 },
              }}
            >
              {stateData.map((stateData) => (
                <SwiperSlide key={stateData.id}>
                  <Link href="#" className="cityBox">
                    <Box className="cityCard">
                      <Box className="cityCardHeading">
                        <h3>{stateData.title}</h3>
                      </Box>
                      <Box className="cityCardImg">
                        <img src={stateData.image} alt={stateData.title} className="img-fluid" />
                      </Box>
                    </Box>
                  </Link>
                </SwiperSlide>
              ))}
             
            </Swiper>
          </Grid>
        </Grid>
      </Container>
    </Box>
    </section>
  );
}

export default Cityslider;
